import { useDispatch, useSelector } from "react-redux"
import AddEqClassCode from "./AddEqClassCode"
import { useEffect, useState } from "react"
import userProfileSelectors from '../../../../../../redux/UserProfile/selectors'
import SuccessBee from "../../../../../assets/images/SuccessBee.svg";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import { getCatalogRemoveEqClassCode, getCatalogUpdateEqClassCode, getCatalogUpdateEqClassCodeSave, setCatalogRemoveEqClassCode, setCatalogUpdateEqClassCodeSave, setCatalogUpdateEqClassCodeValidate } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction"
import { CONSTANTS } from "client/utils/constants";
import { popupInitialData } from "utils";
import { getIsEqClassValidDelete, setIsEqClassValidDelete } from "Store/AssetManagement/CatalogItem/CatalogItemAction";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AddEqClassCodeContainer = (props?: any) => {
    const {
        setEqClassCode,
        eqClassCode,
        setEqClassDescription,
        eqClassDescription,
        ExistingDropDownValue,
        catalogItemValues,
        setEqClassCodePopup,
        validateEqClassValues,
        addEqClassCodeError,
        addEqClassDescriptionError,
        selectedAssetType
    } = props

    const {
        isCatalogUpdateEqClassCodeValid,
        isCatalogEqClassCodeRemoved,
        isCatalogUpdateEqClassCodeSaved,
        userData,
        isEqClassValidForDelete
    }: any = useSelector(
        (state: any) => ({
            userData: userProfileSelectors.getUserDetails(state),
            isCatalogUpdateEqClassCodeValid: state.CatalogDropDownUpdateReducers.isCatalogUpdateEqClassCodeValid,
            isCatalogEqClassCodeRemoved: state.CatalogDropDownUpdateReducers.isCatalogEqClassCodeRemoved,
            isCatalogUpdateEqClassCodeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateEqClassCodeSaved,
            isEqClassValidForDelete: state.CatalogItemReducer.isEqClassValidForDelete
        })
    )

    const dispatch = useDispatch();

    const [PopupcontentComplete, setPopupcontentComplete] = useState<any>(popupInitialData);
    const [deleteTempValue, setDeleteTempValue] = useState<any>(null);

    const hideDialogComplete = () => {
        setPopupcontentComplete({ ...PopupcontentComplete, isDialogVisible: false })
    };

    useEffect(() => {
        if (isCatalogUpdateEqClassCodeSaved && isCatalogUpdateEqClassCodeSaved != null) {
            let decriptionTxt = (<p>Eq Class Code is added successfully.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: SuccessBee,
                title: "SUCCESS",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    setEqClassCodePopup(false)
                    setEqClassCode("")
                    setEqClassDescription('')
                    let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                    dispatch(getCatalogUpdateEqClassCode(subTypeId))
                }
            });
        } else if (!isCatalogUpdateEqClassCodeSaved && isCatalogUpdateEqClassCodeSaved != null) {
            let decriptionTxt = (<p>Error Occured while adding the value.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    setEqClassCode("")
                    setEqClassDescription('')
                    dispatch(setCatalogUpdateEqClassCodeSave(null))
                }
            });
        }
    }, [isCatalogUpdateEqClassCodeSaved])

    useEffect(() => {
        if (isCatalogEqClassCodeRemoved && isCatalogEqClassCodeRemoved != null) {
            let decriptionTxt = (<p>Value is removed successfully.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: SuccessBee,
                title: "SUCCESS",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
                    dispatch(getCatalogUpdateEqClassCode(subTypeId))
                }
            });
        } else if (!isCatalogEqClassCodeRemoved && isCatalogEqClassCodeRemoved != null) {
            let decriptionTxt = (<p>Error Occured while removing the value.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    dispatch(setCatalogRemoveEqClassCode(null))
                }
            });
        }
    }, [isCatalogEqClassCodeRemoved])

    useEffect(() => {
        if (isCatalogUpdateEqClassCodeValid && isCatalogUpdateEqClassCodeValid != null) {
            let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
            dispatch(getCatalogUpdateEqClassCodeSave({
                savedBy: userData?.emailId,
                code: eqClassCode,
                description: eqClassDescription,
                subTypeId: parseInt(subTypeId)
            }))
            dispatch(setCatalogUpdateEqClassCodeValidate(null))


        } else if (!isCatalogUpdateEqClassCodeValid && isCatalogUpdateEqClassCodeValid != null) {
            let decriptionTxt = (<p>Eq Class Code value given already exists.</p>);
            setPopupcontentComplete({
                ...PopupcontentComplete,
                titleImg: ConfirmationBee,
                title: "INFORMATION",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclickComplete: () => {
                    hideDialogComplete()
                    setEqClassCode("")
                    setEqClassDescription('')
                }
            });
            dispatch(setCatalogUpdateEqClassCodeValidate(null))
        }

    }, [isCatalogUpdateEqClassCodeValid])

    const commonPopupData = (descriptionTxt?: any, title?: any) => {
        setPopupcontentComplete({
            ...PopupcontentComplete,
            titleImg: ConfirmationBee,
            title: title,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: descriptionTxt,
            outlineBtnText: "Close",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclickComplete: () => {
                hideDialogComplete()
                setDeleteTempValue(null)
            }
        });
    }

    useEffect(() => {
        if (isEqClassValidForDelete != null ) {
            if (isEqClassValidForDelete == true) {
                dispatch(getCatalogRemoveEqClassCode({
                        savedBy: userData?.emailId,
                        valueId: deleteTempValue?.value
                    }))
            } else if (isEqClassValidForDelete == false) {
                let descriptionTxt = (<p>Unable to delete the Eq Class Code.  The Eq Class Code exist for an active catalog item.</p>);
                commonPopupData(descriptionTxt, "INFORMATION")
            } else if ( isEqClassValidForDelete == 'error') {
                let decriptionTxt = (<p>Error Occured while validating.</p>);
                commonPopupData(decriptionTxt, "ERROR")
            }
            dispatch(setIsEqClassValidDelete(null));
        }

    }, [isEqClassValidForDelete])

    const removeItem = (item?: any) => {
        if (!isAuthorized(permissions.CreateEditCatalog)) return;
        setDeleteTempValue(item)
        dispatch(getIsEqClassValidDelete({
            savedBy: userData?.emailId,
            valueId: parseInt(item?.value),
            subTypeId: parseInt(catalogItemValues?.vehicleType?.orderRequestSubTypeId)
        }))
    }

    const handleOnChange = (e: any, typeVal: any) => {
        validateEqClassValues(typeVal, e.target.value)
        if (typeVal == "Code") {
            setEqClassCode(e.target.value)
        } else {
            setEqClassDescription(e.target.value)
        }
    }

    return (
        <AddEqClassCode
            ExistingDropDownValue={ExistingDropDownValue}
            eqClassCode={eqClassCode}
            eqClassDescription={eqClassDescription}
            handleOnChange={handleOnChange}
            removeItem={removeItem}
            hideDialogComplete={hideDialogComplete}
            PopupcontentComplete={PopupcontentComplete}
            addEqClassCodeError={addEqClassCodeError}
            addEqClassDescriptionError={addEqClassDescriptionError}
            catalogItemValues = {catalogItemValues}
        />
    )
}

export default AddEqClassCodeContainer